export function easeOutCubic(t, b, _c, d) {
    const c = _c - b;
    return c * ((t = t / d - 1) * t * t + 1) + b;
}

export function animate(startValue, endValue, duration, fn) {
    let startTime;
    let rafId;
    function step(timestamp) {
        if (!startTime) {
            startTime = timestamp;
        }
        const elapsed = timestamp - startTime;
        let computed = easeOutCubic(elapsed, startValue, endValue, duration);
        if (elapsed >= duration) {
            fn(endValue);
            window.cancelAnimationFrame(rafId);
        } else {
            fn(computed);
            rafId = window.requestAnimationFrame(step);
        }
    }
    rafId = window.requestAnimationFrame(step);
    return () => window.cancelAnimationFrame(rafId);
}
